import React, { useState } from "react";

const ViewInjSpecial = ({ stepData }: any) => {

    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Special Tests</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Body Part</th>
                                            <th>Test Name</th>
                                            <th>Right Value</th>
                                            <th>Left Value</th>
                                            <th>Remarks</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepData.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>{row.body_part}</td>
                                                <td>{row.test_name}</td>
                                                <td>{row.val_1}</td>
                                                <td>{row.val_2}</td>
                                                <td>{row.remarks}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewInjSpecial;